import { Col, Row } from 'antd';
import { customerConst } from '../../../../../constants';
import { phoneMask, getFullName } from '../../../../../util';

export const CustomerData = ({ data }) => {
  const phone = data?.phone ?? data?.tutor?.mobilePhone;
  const phonePrefix = data?.mobilePhone
    ? data?.phonePrefix
    : data?.tutor?.phonePrefix;

  return (
    <>
      <Row className="row">
        <Col span={8}>
          <h4>Género</h4>
        </Col>
        <Col span={16}>{data?.gender || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{customerConst.contactLabels.phone}</h4>
        </Col>
        <Col span={16}>{phoneMask(phone) || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{customerConst.contactLabels.phonePrefix}</h4>
        </Col>
        <Col span={16}>{phonePrefix || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Estado civil</h4>
        </Col>
        <Col span={16}>{data?.maritalStatus || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Nacionalidad</h4>
        </Col>
        <Col span={16}>{data?.nationality || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>Referencia</h4>
        </Col>
        <Col span={16}>{data?.reference || '-'}</Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h5 className="strong"> Tutor</h5>
        </Col>
        <Col span={16}>{getFullName(data?.tutor)}</Col>
      </Row>
      <Row className="row">
        <Col span={8}>
          <h4>Parentesco</h4>
        </Col>
        <Col span={16}>{data?.relationship || '-'}</Col>
      </Row>
    </>
  );
};
